import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Link} from 'react-router-dom';
import Breadcrumbs from '../../breadcrumbs';
import {Grid} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {Map} from 'immutable';

import {Wrapper} from 'system/wrapper';
import CardsInstitutions from 'system/cards-institutions';
import Spinner from '../../../spinner';
import Input from 'form/input';
import {Label, Select, UniversalSelectWrapper, SearchWrapperPortalLowWrap} from 'components/common';
import {ButtonDefault} from 'components/buttons';
import Pagination from 'pagination';

import {searchInstitutionsByLevelWithoutCivil, loadAllTypes} from '../../../redux/actions/portal/institutions';

import hospital from 'images/general/hospital.svg';

const mapStateToProps = (state) => ({
  institutions: state.institutions.get('institutionsList'),
  isFetching: state.institutions.get('institutionsIsLoading'),
  user: state.auth.get('user'),

  allTypes: state.institutions.get('allTypes'),
  allTypesAreLoading:  state.institutions.get('allTypesAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: level => dispatch(loadAllTypes(level)),
  onSearch: (name, type, offset) => dispatch(searchInstitutionsByLevelWithoutCivil(name, type, 2, 12, offset))
});

const types = allTypes => {
   return allTypes.filter(function(el) {
    if (el.get('code').substring(0,2) !== '02'){
      return el;
    }
  })
}


class Institutions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      type: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
      this.onChangeType = this.onChangeType.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  onChangeType(event){
      this.setState({
          type: event.target.value
      })
  }

  onSubmitForm = event => {
    event.preventDefault();
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    page != 1
      ? this.props.history.push(`/institutions/1`)
      : this.props.onSearch(this.state.name, this.state.type, offset)
  }

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    this.props.onSearch(this.state.name, this.state.type, offset)
    const hierarchyLevel = 2
    this.props.onLoad(hierarchyLevel)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 12 * (page - 1);
      this.props.onSearch(this.state.name, this.state.type,  offset)
    }
  }

  render() {
    if (this.props.institutions === undefined) {
      return (
        <Wrapper>
          <Spinner />
        </Wrapper>
      )
    }

    if (this.props.allTypesAreLoading){
      return (
        <Wrapper>
        <Spinner />
      </Wrapper>
      )
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/institutions">Установи</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Установи</h2>
            <SearchWrapperPortalLowWrap onSubmit={this.onSubmitForm}>
              <Input
                block
                placeholder="Введіть назву або код ЄДРПОУ установи"
                label="Пошук за назвою або кодом ЄДРПОУ установи"
                value={this.state.name}
                onChange={this.changeSearchName}
              />

              <UniversalSelectWrapper>
              <Label>Тип установи</Label>
              <Select value={this.state.type} onChange={this.onChangeType}>
                <option selected value="">Всі типи</option>
                {types(this.props.allTypes.get('results')).map((item, i) => (
                  <option key={i} value={item.get('code')}>{item.get('code')} {item.get('title')}</option>
                ))}
              </Select>
              </UniversalSelectWrapper>

              <ButtonDefault type="submit" value="Пошук" />
            </SearchWrapperPortalLowWrap>

              {this.props.isFetching ? (
              <Spinner />
            ):(
              <div>
                {this.props.institutions.get('results').size > 0 ? (
                  <CardsInstitutions >
                     {this.props.institutions.get('results').map((item, i) => (
                  <li key={i}  style={{backgroundImage: `url(${item.get('photo') ? item.get('photo') : null})`, backgroundSize: "cover ", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}>
                      {item.get('photo') ? (
                     null
                    ):(
                      <img src={hospital} alt="hospital"/>
                    )}

                    <Link to={`/institutions/detail/${item.get('id')}`}>
                      <div>
                      <h3>{item.get('full_title')}</h3>
                      <p>{item.get('address')}</p>
                      </div>
                    </Link>
                  </li>
                ))}
                  </CardsInstitutions>
                ):(
                  <h3>За таким запитом установи відсутні</h3>
                )}
              </div>
            )}

            <Pagination counts={this.props.institutions.get('count')} path={`/institutions/`} matched={this.props.match.params.page} limits={12} />
          </Grid>
        </Wrapper>
      </div>
    )
  }
}


Institutions.propTypes = {
  institutions: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Institutions));



// WEBPACK FOOTER //
// ./src/system/main/institutions/index.js